import colors from '_containers/Theme/corporate/colors';


export default {
  pathFillColor: colors.text.nonessential
}
